<template>
  <div id="app">
    <!-- <div class="header-modular">
      <MyHeader></MyHeader>
    </div> -->
    <!-- <ShareRight></ShareRight> -->

    <router-view v-if="isReload" />
    <!-- <div class="footer-modualr"> -->
    <!-- <MyFooter></MyFooter> -->
    <!-- </div> -->
  </div>
</template>

<script>
import MyHeader from "./components/public/header";
import headerMenu from "./components/public/headerMenu";
import ShareRight from "./components/public/publicRight";
import MyFooter from "./components/public/footer";


export default {
  components: {
    MyHeader,
    MyFooter,
    headerMenu,
    ShareRight,
  },
  name: "App",
  data() {
    return {
      isReload: true,
    };
  },
  methods: {
    /**
     * 判断手机型号
     */
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },

    /**
     * 页面刷新
     */
    reload() {
      this.isReload = false;
      this.$nextTick(() => {
        this.isReload = true;
      });
    },

    /**
     * 语言翻译
     * @param {*} text
     */
    translate(text, callback, errCallBack) {
      let that = this;

      let data = {
        text: text, //带翻译文本
        from: localStorage.getItem("oldLanguageCode"), //源语言
        to: localStorage.getItem("curLanguageCode"), //目标语言
      };
      if (data.from == data.to) {
        return;
      }
      this.$http.translate(data, callback, errCallBack);
    },

    /**
     * vue语言国际化切换
     * @param {*} value
     */
    lang_change(value) {
      console.log("value---", value);
      // return
      // debugger
      switch (parseInt(value)) {
        case 0: // 中文
          this.$i18n.locale = "zh";
          this.set_cookie("lang", "zh", 7); // 第一个参数是名字，第二个参数是当前的语言，第三个参数是表示 cookie 过期时间，可能是6（天）
          localStorage.setItem("locale", "zh");
          break;
        case 1: // 中文
          this.$i18n.locale = "zh";
          this.set_cookie("lang", "zh", 7); // 第一个参数是名字，第二个参数是当前的语言，第三个参数是表示 cookie 过期时间，可能是6（天）
          localStorage.setItem("locale", "zh");
          break;
        case 3: // 英语
          this.$i18n.locale = "en";
          this.set_cookie("lang", "en", 7);
          localStorage.setItem("locale", "en");
          break;
        case 4: // 日语
          this.$i18n.locale = "ja";
          this.set_cookie("lang", "ja", 7);
          localStorage.setItem("locale", "ja");
          break;
        case 5: // 韩语
          this.$i18n.locale = "ko";
          this.set_cookie("lang", "ko", 7);
          localStorage.setItem("locale", "ko");
          break;
        case 6: // 荷兰语
          this.$i18n.locale = "nl";
          this.set_cookie("lang", "nl", 7);
          localStorage.setItem("locale", "nl");
          break;
        case 7: // 越南语
          this.$i18n.locale = "vi";
          this.set_cookie("lang", "vi", 7);
          localStorage.setItem("locale", "vi");
          break;
        case 8: // 俄语
          this.$i18n.locale = "ru";
          this.set_cookie("lang", "ru", 7);
          localStorage.setItem("locale", "ru");
          break;
        case 9: // 葡萄牙语
          this.$i18n.locale = "pt";
          this.set_cookie("lang", "pt", 7);
          localStorage.setItem("locale", "pt");
          break;
        case 10: // 意大利语
          this.$i18n.locale = "it";
          this.set_cookie("lang", "it", 7);
          localStorage.setItem("locale", "it");
          break;
        case 11: // 印度尼西亚语
          this.$i18n.locale = "id";
          this.set_cookie("lang", "id", 7);
          localStorage.setItem("locale", "id");
          break;
          id;
        case 12: // 法语
          this.$i18n.locale = "fr";
          this.set_cookie("lang", "fr", 7);
          localStorage.setItem("locale", "fr");
          break;
        case 13: // 西班牙语
          this.$i18n.locale = "es";
          this.set_cookie("lang", "es", 7);
          localStorage.setItem("locale", "es");
          break;
        case 14: // 德语
          this.$i18n.locale = "de";
          this.set_cookie("lang", "de", 7);
          localStorage.setItem("locale", "de");
          break;
        case 15: // 泰语
          this.$i18n.locale = "th";
          this.set_cookie("lang", "th", 7);
          localStorage.setItem("locale", "th");
          break;
        case 16: // 阿拉伯语
          this.$i18n.locale = "ar";
          this.set_cookie("lang", "ar", 7);
          localStorage.setItem("locale", "ar");
          break;

        default:
          this.$i18n.locale = "zh";
          this.set_cookie("lang", "zh", 7); // 第一个参数是名字，第二个参数是当前的语言，第三个参数是表示 cookie 过期时间，可能是6（天）
          localStorage.setItem("locale", "zh");
          break;
      }
      // return
      // if (value == 0 || value == 1) {
      //   this.$i18n.locale = "zh";
      //   this.set_cookie('lang', 'zh', 7); // 第一个参数是名字，第二个参数是当前的语言，第三个参数是表示 cookie 过期时间，可能是6（天）
      // } else if (value == 3) {
      //   this.$i18n.locale = "en";
      //   this.set_cookie('lang', 'en', 7);
      // }
    },
  },
  mounted() {
    if (this._isMobile()) {
      // alert("手机端");
      localStorage.setItem("equipmentType", 1);
    } else {
      // alert("pc端");
      localStorage.setItem("equipmentType", 0);
    }
  },
  getUrlParam(key) {
    let query = window.location.search.substring(1);
    let vars = query.split("&");
    for (let i = 0; i < vars.length; i++) {
      let pair = vars[i].split("=");
      if (pair[0] == key) {
        return pair[1];
      }
    }
    return null;
  },
};
</script>


<style>
@import "./assets/fonts/fonts.css";
* {
  margin: 0;
  padding: 0;
}

::-webkit-scrollbar {
  width: 0 !important;
}
::-webkit-scrollbar {
  width: 0 !important;
  height: 0;
}

.el-header,
.el-footer,
.el-main {
  margin: 0;
  padding: 0;
}

.el-footer {
  height: unset !important;
}

html,
body {
  width: 100%;
  background-color: #ebf2fd;
  height: 100%;
  /* font-family:"Segoe UI", Helvetica,  Arial, Tahoma, Geneva, Verdana, sans-serif !important; */
  font-family:'Roboto', sans-serif;
}
#app {
  /* width: 1920px; */
  width: 100%;
  margin: auto;
  height: 100%;
  /* overflow-x: hidden; */
}

#app {
  position: relative;
}
.el-button--primary {
  background-color: #5E69AD;
    border-color: #5E69AD;
}

@media screen and (max-width: 500px) {
  html,
  body,
  #app {
    overflow-x: hidden;
    width: 100% !important;
  }
}

/* #app {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
} */
p {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue